<template>
  <div>
    <div class="flex-column-center tech-phone">
      <el-container id="materialTechnology">
        <el-header>
          <h3 class="nesc_title40">{{ $t('lang.materialTechnology') }}</h3>
        </el-header>
        <el-main>
          <div class="nesc_cont1360 nesc_about_content clearfix">
            <el-row type="flex" class="row-bg" justify="center">
              <el-col class="flex-row-center" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <img src="../assets/image/technology/cailiao.jpeg?v=1" style="width: 100%;">
              </el-col>
            </el-row>
          </div>
        </el-main>
      </el-container>
      <el-container id="structuralTechnology">
        <el-header>
          <h3 class="nesc_title40">{{ $t('lang.structuralTechnology') }}</h3>
        </el-header>
        <el-main>
          <div class="nesc_cont1360 nesc_about_content clearfix">
            <el-row type="flex" class="row-bg" justify="center">
              <el-col class="flex-row-center" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <img src="../assets/image/technology/jiegou.jpeg?v=1" style="width: 100%;">
              </el-col>
            </el-row>
          </div>
        </el-main>
      </el-container>
      <el-container id="cloudPlatform">
        <el-header>
          <h3 class="nesc_title40">{{ $t('lang.cloudPlatform') }}</h3>
        </el-header>
        <el-main>
          <div class="nesc_cont1360 nesc_about_content clearfix">
            <el-row type="flex" class="row-bg" justify="center">
              <el-col class="flex-row-center" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <img src="../assets/image/technology/platform.jpeg?v=1" style="width: 100%;">
              </el-col>
            </el-row>
          </div>
        </el-main>
      </el-container>
    </div>

    <el-container class="tech-pc">
      <swiper ref="mySwiper" class="swiper" :options="swiperOption">
        <swiper-slide>
          <div class="swiper-slide__item">
            <h3 class="nesc_title40 fadeInUp">{{ $t('lang.materialTechnology') }}</h3>
            <img src="../assets/image/technology/cailiao.jpeg">
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="swiper-slide__item">
            <h3 class="nesc_title40 fadeInUp">{{ $t('lang.structuralTechnology') }}</h3>
            <img src="../assets/image/technology/jiegou.jpeg">
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="swiper-slide__item">
            <h3 class="nesc_title40 fadeInUp">{{ $t('lang.cloudPlatform') }}</h3>
            <img src="../assets/image/technology/platform.jpeg">
          </div>
        </swiper-slide>
        <div slot="pagination" class="swiper-pagination" />
      </swiper>
    </el-container>
  </div>

</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'Tech',

  components: {
    swiper,
    swiperSlide
  },
  data: () => {
    return {
      swiperOption: {
        direction: 'vertical',
        slidesPerView: 1,
        spaceBetween: 20,
        mousewheel: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },

  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },

  watch: {
    '$route': {
      handler: 'scrollToPosition',
      immediate: true
    }
  },

  mounted() {

  },

  methods: {
    scrollToPosition(param) {
      console.log(param)
      if (param.name && param.name == 'technology') {
        const type = param.params.type == 'materialTechnology' ? 0 : param.params.type == 'structuralTechnology' ? 1
          : param.params.type == 'cloudPlatform' && 2

        setTimeout(() => {
          this.swiper.slideTo(type)
        }, 10)
      }
    }
  }
}
</script>

<style scoped lang="scss">

.tech-phone {
  display: none;
  @media screen and (max-width: 992px){
    display: block;
  }
}

.el-header {
  height: auto !important;
  @media screen and (max-width: 992px){
    margin: 34px 0 20px;
  }
}
.el-main {
  margin-bottom: 100px;
  overflow: visible !important;
  min-height: auto !important;
  @media screen and (max-width: 992px){
    margin-bottom: 20px;
  }
}

.nesc_about_content {
  position: relative;
  z-index: 1;
  overflow: visible !important;
  margin: 0 auto;
}

.el-container img {
  box-shadow: 0 0px 5px  rgba(214,211,211,0.7)
}

.tech-pc {
  @media screen and (max-width: 992px){
    display: none;
  }
}

.swiper{
  height: calc(100vw*850/1920);
  width: 100%;
  display: block;
  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-weight: bold;
    font-size: 24px;
    background-color: #ffffff;
    height: 100%;

    .swiper-slide__item {
      width: 100%;
      height: 100%;
      position: relative;
      img {
        width: 100%; height: 100%;
        max-height: 850px;
      }
      h3 {
        position: absolute;
        top: 100px;
        left: 100px;
        color: #ffffff;
      }
    }
  }
}

::v-deep .swiper-pagination-bullet-active {
  background: #ffffff !important;
}

::v-deep.swiper-slide-active {
  .fadeInUp {
    animation: fadeInUp;
    animation-duration: 1.2s;
  }
}

</style>
